import { render, staticRenderFns } from "./ArrowDropdown.vue?vue&type=template&id=8fe08dfc&"
import script from "./ArrowDropdown.vue?vue&type=script&lang=js&"
export * from "./ArrowDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports